import { create } from "zustand";
import { fetchBrandKit, updateBrandKit, generateBrandKit, generateVisualStyle } from "./brandKitApi";
import { notifications } from "@mantine/notifications";

export const useBrandKitStore = create((set, get) => ({
  kit: null,
  isLoading: false,
  isSaving: false,
  isGenerating: false,
  isGeneratingVisualStyle: false,

  fetchKit: async (brandId) => {
    set({ isLoading: true });
    try {
      const kit = await fetchBrandKit(brandId);
      set({ kit, isLoading: false });
      return kit;
    } catch (err) {
      notifications.show({
        title: "Failed to load brand kit",
        color: "red",
      });
      set({ isLoading: false });
    }
  },

  saveKit: async (brandId, data) => {
    set({ isSaving: true });
    try {
      const kit = await updateBrandKit(brandId, data);
      set({ kit, isSaving: false });
      notifications.show({
        title: "Brand kit saved",
        color: "green",
      });
      return kit;
    } catch (err) {
      notifications.show({
        title: "Failed to save brand kit",
        message: err.message,
        color: "red",
      });
      set({ isSaving: false });
      throw err;
    }
  },

  generateVisualStyle: async (brandId) => {
    set({ isGeneratingVisualStyle: true });
    try {
      const style = await generateVisualStyle(brandId);
      notifications.show({
        title: "Visual style suggested",
        message: "Review the suggested style and save when ready",
        color: "green",
      });
      set({ isGeneratingVisualStyle: false });
      return style;
    } catch (err) {
      notifications.show({
        title: "Failed to suggest visual style",
        message: err.message,
        color: "red",
      });
      set({ isGeneratingVisualStyle: false });
      throw err;
    }
  },

  generateKit: async (brandId) => {
    set({ isGenerating: true });
    try {
      const generated = await generateBrandKit(brandId);
      notifications.show({
        title: "Brand kit generated",
        message: "Review the generated content and save when ready",
        color: "green",
      });
      set({ isGenerating: false });
      return generated;
    } catch (err) {
      notifications.show({
        title: "Failed to generate brand kit",
        message: err.message,
        color: "red",
      });
      set({ isGenerating: false });
      throw err;
    }
  },
}));
